import { ColumnDef } from "@tanstack/react-table";
import { z, ZodObject, ZodRawShape } from "zod";
import LicensePlate from "license-plate";
import licencePlateSelectBg from "../../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";

export const TruckTableColumns: ColumnDef<z.infer<ZodObject<ZodRawShape>>>[] = [
  {
    id: "licence",
    accessorKey: "licence",
    header: "licence",
    meta: {
      columnAction: "/truck/:id/edit",
    },
    cell: ({ row }) => {
      const plate = new LicensePlate(row.original.licence ?? "");

      return (
        <div className={"d-flex align-items-center gap-2"}>
          {row.original.licence && (
            <div
              className={"tireset-table-licence-plate"}
              style={{
                background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
              }}
            >
              <div>{plate.valid() ? plate.pretty() : row.original.licence}</div>
            </div>
          )}
        </div>
      );
    },
  },
  {
    id: "capacity",
    accessorKey: "capacity",
    header: "capacity",
  },
  {
    id: "title",
    accessorKey: "title",
    header: "title",
  },
  {
    id: "driver",
    accessorKey: "driver.name",
    header: "driver",
    cell: ({ row }) => {
      return row.original.driver?.name ?? row.original.driver?.username;
    },
  },
];
